import { ReportProcess } from '@/models/ReportProcess';
import { AxiosError } from 'axios';

export enum ReportTypes {
    GENERATE_ASYNC_REPORT_REQUEST = '@REPORT/GENERATE_ASYNC_REPORT_REQUEST',
    GENERATE_ASYNC_REPORT_SUCCESS = '@REPORT/GENERATE_ASYNC_REPORT_SUCCESS',
    GENERATE_ASYNC_REPORT_FAILURE = '@REPORT/GENERATE_ASYNC_REPORT_FAILURE',
    GENERATE_ASYNC_REPORT_CLEAR = '@REPORT/GENERATE_ASYNC_REPORT_CLEAR',

    LIST_REPORT_PROCESSES_REQUEST = '@REPORT/LIST_REPORT_PROCESSES_REQUEST',
    LIST_REPORT_PROCESSES_SUCCESS = '@REPORT/LIST_REPORT_PROCESSES_SUCCESS',
    LIST_REPORT_PROCESSES_FAILURE = '@REPORT/LIST_REPORT_PROCESSES_FAILURE',

    DOWNLOAD_LAST_REPORT_REQUEST = '@REPORT/DOWNLOAD_LAST_REPORT_REQUEST',
    DOWNLOAD_LAST_REPORT_SUCCESS = '@REPORT/DOWNLOAD_LAST_REPORT_SUCCESS',
    DOWNLOAD_LAST_REPORT_FAILURE = '@REPORT/LIST_REPORT_PROCESSES_FAILURE',
}

export interface ReportState {
    data: ReportProcessData[];
    loading: boolean;
    successOnGenerateAsyncReport: boolean;
    errorOnGenerateAsyncReport: boolean;
    currentReportId?: number;
    error?: AxiosError;
}

export interface ReportProcessData {
    reportId: number;
    reportProcesses: ReportProcess[];
}
